/*
 * quote-trigger.js
 *
 * Two responsibilities on the product page:
 *
 * 1) Hides the native Add to Cart button (and dynamic checkout buttons) when
 *    any selected option contains the word "Quote". The Quotify "Request
 *    Quote" button is always visible.
 *
 *    Sources of selected values:
 *      - Variant option selections (radios or selects inside <variant-selects>)
 *      - Family selector radios ([data-family-selector] input:checked)
 *      - Extra option radios ([data-extra-option] input:checked)
 *
 *    Targets that toggle:
 *      - ATC: button.product-form__submit
 *      - Dynamic checkout: .shopify-payment-button, .additional-checkout-buttons
 *
 *    The trigger word match is case-insensitive on the substring "quote".
 *
 * 2) Relocates the Quotify Request Quote button into the buy-buttons area —
 *    placed directly after the Shop Pay button and above the installments
 *    message — so it sits inline with the rest of the purchase actions.
 */
(function () {
  if (window.__quoteTriggerBound) return;
  window.__quoteTriggerBound = true;

  var QUOTE_RE = /quote/i;

  function getVariantOptionValues() {
    var values = [];
    document.querySelectorAll('variant-selects').forEach(function (vs) {
      vs.querySelectorAll('.product-form__input').forEach(function (group) {
        var checked = group.querySelector('input[type="radio"]:checked');
        if (checked && checked.value) {
          values.push(checked.value);
          return;
        }
        var select = group.querySelector('select');
        if (select && select.value) {
          values.push(select.value);
        }
      });
    });
    return values;
  }

  function getFamilyValues() {
    var values = [];
    var selectors = [
      '[data-family-selector] input[type="radio"]:checked',
      '[data-family-selector] input[data-current="true"]'
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.value) values.push(el.value);
      });
    });
    return values;
  }

  function getExtraOptionValues() {
    var values = [];
    document
      .querySelectorAll('[data-extra-option] input[type="radio"]:checked')
      .forEach(function (el) {
        values.push(el.dataset.extraOptionValue || el.value || '');
      });
    return values;
  }

  function shouldShowQuote() {
    var all = []
      .concat(getVariantOptionValues())
      .concat(getFamilyValues())
      .concat(getExtraOptionValues());
    for (var i = 0; i < all.length; i++) {
      if (all[i] && QUOTE_RE.test(all[i])) return true;
    }
    return false;
  }

  function setDisplay(elements, hidden) {
    elements.forEach(function (el) {
      el.style.display = hidden ? 'none' : '';
    });
  }

  function applyState() {
    var quoteMode = shouldShowQuote();

    var atcBtns = document.querySelectorAll('button.product-form__submit');
    var dynamicCheckout = document.querySelectorAll(
      '.shopify-payment-button, .additional-checkout-buttons'
    );

    // ATC and dynamic checkout (Shop Pay / Buy It Now) toggle together — both
    // hidden when in quote mode, both shown otherwise. The Quotify "Request
    // Quote" button is left visible at all times.
    setDisplay(atcBtns, quoteMode);
    setDisplay(dynamicCheckout, quoteMode);
  }

  // Moves the Quotify Request Quote button into the buy-buttons area, placing
  // it directly after the Shop Pay button and (if present) before the Shop
  // Pay installments message. Idempotent — safe to call repeatedly.
  function relocateQuoteButton() {
    var quoteEl =
      document.querySelector('quotify-button') ||
      document.querySelector('.quotify-request-quote-btn');
    if (!quoteEl) return false;

    // If we found the inner <button>, walk up to its <quotify-button> wrapper
    // (or whatever stable parent the app uses) so we move the whole block.
    var quoteBlock = quoteEl.closest('quotify-button') || quoteEl;

    // Locate the Shop Pay area inside the product form.
    var productForm =
      document.querySelector('.main-product-form') ||
      document.querySelector('.product-form');
    if (!productForm) return false;

    var shopPay =
      productForm.querySelector('.shopify-payment-button') ||
      productForm.querySelector('shopify-payment-button');
    if (!shopPay) return false;

    // The installments terms are typically a sibling of .shopify-payment-button.
    // We want quote button between Shop Pay button and installments.
    var installments =
      productForm.querySelector('shopify-payment-terms') ||
      productForm.querySelector('.shopify-payment-terms') ||
      productForm.querySelector('shop-pay-installments');

    var insertBeforeNode;
    if (installments && installments.parentNode === shopPay.parentNode) {
      // Installments is a sibling of shopPay — put Quotify between them.
      insertBeforeNode = installments;
    } else {
      // No sibling installments — just put Quotify directly after Shop Pay.
      insertBeforeNode = shopPay.nextSibling;
    }

    var targetParent = shopPay.parentNode;

    // Idempotency check: if quoteBlock is already in the right place, bail.
    if (
      quoteBlock.parentNode === targetParent &&
      quoteBlock.previousElementSibling === shopPay
    ) {
      return true;
    }

    targetParent.insertBefore(quoteBlock, insertBeforeNode);
    return true;
  }

  function init() {
    applyState();
    // Re-evaluate on any input change. applyState is cheap.
    document.addEventListener('change', applyState);
    // Re-apply after Shopify section reloads (variant changes can re-render parts of main-product).
    document.addEventListener('shopify:section:load', applyState);

    // Try to move the Quotify button into place. If it isn't in DOM yet,
    // watch for it and Shop Pay both being present, then relocate.
    if (!relocateQuoteButton()) {
      if ('MutationObserver' in window) {
        var observer = new MutationObserver(function () {
          if (relocateQuoteButton()) {
            observer.disconnect();
            applyState();
          }
        });
        observer.observe(document.body, { childList: true, subtree: true });
        // Stop watching after 10 seconds regardless.
        setTimeout(function () {
          observer.disconnect();
        }, 10000);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
